import React, {Component} from 'react';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import actionCreators from 'actions/creators';
import GLOBAL from 'jcolorglobal';
import classNames from "classnames";
import CupoyRouter from "components/commons/router/CupoyRouter";

class CreateInvoiceView extends Component {

    constructor(props) {
        super(props);

        this.state = {
            yearMonth: undefined,
            orderid: '',
            mrscid: '',
            buyerName: '',
            buyerCrn: '',
            buyerEmail: '',
            invoiceTime: Date.now(),
            invoiceSendAddress: '',
            srcType: GLOBAL.SRCTYPE.JCOLOR,
            isDonate: false,
            loveCode: '',
            carrierType: GLOBAL.CARRIER_TYPE.CITIZEN_CERT.value,
            carrierId1: '',
            carrierId2: '',
            isTriCpoy: false,
            printMark: 'N',
            pdtlist: [
                {
                    pdtname: '',
                    pdtcount: 0,
                    pdtprice: 0,
                    pdtid: '',
                    isParamsErrorMap: {},
                }
            ],
            isLoading: false,
            errorMsg: '',
            isParamsError: false,
            isParamsErrorMap: {},
        };

        this.handleSubmit = this.handleSubmit.bind(this);
    }

    // ------------------------------
    // componentDidMount
    // ------------------------------
    componentDidMount() {

        this.getEmptyInvoiceYearmonthList();
    }

    // ------------------------------
    // 取得空白發票存在的期別列表 
    // ------------------------------
    getEmptyInvoiceYearmonthList() {

        const yearmonthList = this.props.yearmonthList;

        if(!Array.isArray(yearmonthList) || yearmonthList.length === 0) {
            this.props.emptyInvoiceActions.getEmptyInvoiceYearmonthList().then((result) => {
                if(Array.isArray(result) && result.length > 0) {

                    if(result.indexOf(GLOBAL.NOW_YEARMONTH) !== -1) {
                        this.setState({
                            yearMonth: GLOBAL.NOW_YEARMONTH,
                        });
                    } else {
                        this.setState({
                            yearMonth: result[0],
                        });
                    }
                }
            });
        } else {
            if(yearmonthList.indexOf(GLOBAL.NOW_YEARMONTH) !== -1) {
                this.setState({
                    yearMonth: GLOBAL.NOW_YEARMONTH,
                });
            } else {
                this.setState({
                    yearMonth: yearmonthList[0],
                });
            }
        }
    }

    onInputChange(fieldname, event) {

        this.setState({
            [fieldname]: event.target.value
        })
    }

    onPdtlistInputChange(index, fieldname, event) {

        const pdt = this.state.pdtlist[index];
        const newpdt = Object.assign({}, pdt, {
            [fieldname]: event.target.value
        });
        const newpdtlist = this.state.pdtlist;
        newpdtlist[index] = newpdt;

        this.setState({
            pdtlist: newpdtlist,
        });
    }

    expandPdtlist() {

        let newpdtlist = this.state.pdtlist;

        newpdtlist.push({
            pdtname: '',
            pdtcount: 0,
            pdtprice: 0,
            pdtid: '',
            isParamsErrorMap: {},
        });

        this.setState({
            pdtlist: newpdtlist
        });
        
    }

    removeProduct(index) {

        let newpdtlist = this.state.pdtlist;

        if(newpdtlist.length < 1) {
            return;
        }

        newpdtlist.splice(index , 1);

        this.setState({
            pdtlist: newpdtlist
        });
        
    }

    changeIsTriCpoy(isTriCpoy) {

        this.setState({
            isTriCpoy: isTriCpoy,
        })
    }

    changeOption(isDonate, isPrintMark) {

        var carrierType = this.state.carrierType;

        if(isDonate && carrierType === GLOBAL.CARRIER_TYPE.MEMBER.value) {
            carrierType = '';
        } else if(!isDonate && !carrierType) {
            carrierType =  GLOBAL.CARRIER_TYPE.MEMBER.value;
        }

        this.setState({
            isDonate: isDonate,
            printMark: isPrintMark ? 'Y' : 'N',
            carrierType: carrierType,
        })
    }

    handleSubmit(event) {

        event.preventDefault();

        if (this.state.isLoading) {
            return;
        }

        const {
            yearMonth,
            invoiceTime,
            buyerName,
            orderid,
            mrscid,
            srcType,
            invoiceSendAddress,
            isDonate,
            isTriCpoy,
            loveCode,
            buyerCrn,
            printMark,
            carrierType,
            carrierId1,
            carrierId2,
            buyerEmail,
            pdtlist,
        } = this.state;

        var isParamsError = false;
        var isParamsErrorMap = {};

        if(!buyerName) {
            isParamsErrorMap['buyerName'] = true;
            isParamsError = true;
        }

        if(!orderid) {
            isParamsErrorMap['orderid'] = true;
            isParamsError = true;
        }

        if(!mrscid) {
            isParamsErrorMap['mrscid'] = true;
            isParamsError = true;
        }
        
        if(!invoiceSendAddress) {
            isParamsErrorMap['invoiceSendAddress'] = true;
            isParamsError = true;
        }

        if(!buyerEmail) {
            isParamsErrorMap['buyerEmail'] = true;
            isParamsError = true;   
        }

        var salesAmount = 0; // 未稅總價

        for(var i = 0; i < pdtlist.length; i++) {
            var product = pdtlist[i];

            product.isParamsErrorMap = {};
            
            if(!product.pdtname) {
                product.isParamsErrorMap['pdtname'] = true;
                isParamsError = true;
            }
            if(!product.pdtid) {
                product.isParamsErrorMap['pdtid'] = true;
                isParamsError = true;
            }
            if(isNaN(product.pdtcount) || product.pdtcount < 1) {
                product.isParamsErrorMap['pdtcount'] = true;
                isParamsError = true;
            }
            if(isNaN(product.pdtprice)) {
                product.isParamsErrorMap['pdtprice'] = true;
                isParamsError = true;
            }
            if(!product.isParamsErrorMap['pdtcount'] && !product.isParamsErrorMap['pdtprice']) {
                salesAmount = salesAmount + product.pdtcount * product.pdtprice;
            } 
        }

        var payload = {
            yearMonth: yearMonth,
            invoiceTime: invoiceTime,
            buyerName: buyerName,
            salesAmount: Math.round(salesAmount), // 未稅總價
            orderid: orderid,
            mrscid: mrscid,
            srcType: srcType,
            invoiceSendAddress: invoiceSendAddress,
            buyerEmail: buyerEmail,
            pdtlist: pdtlist,
        };

        if(isTriCpoy) {
            if(!buyerCrn) {
                isParamsErrorMap['buyerCrn'] = true;
                isParamsError = true;
            } else {
                payload.buyerCrn = buyerCrn;
            }

            payload.printMark = 'Y';
        } else {
            if (isDonate) {
                if(!loveCode) {
                    isParamsErrorMap['loveCode'] = true;
                    isParamsError = true;
                }

                payload.printMark = 'N';
                payload.isDonate = isDonate;
                payload.loveCode = loveCode;
                payload.carrierType = carrierType;
            } else {
                if(printMark === 'N') {

                    payload.carrierType = carrierType;

                    if(carrierType !== GLOBAL.CARRIER_TYPE.MEMBER.value) {

                        if(!carrierId1) {
                            isParamsErrorMap['carrierId1'] = true;
                            isParamsError = true;
                        }
                        if(!carrierId2) {
                            isParamsErrorMap['carrierId2'] = true;
                            isParamsError = true;
                        }

                        payload.carrierId1 = carrierId1;
                        payload.carrierId2 = carrierId2;
                    }                    
                }

                payload.printMark = printMark;
            }
        }

        if(isParamsError) {

            this.setState({
                pdtlist: pdtlist,
                isParamsError: isParamsError,
                isParamsErrorMap: isParamsErrorMap,
            })

            return;
        }

        this.setState({
            isLoading: true,
            errorMsg: '',
            pdtlist: pdtlist,
            isParamsError: isParamsError,
            isParamsErrorMap: isParamsErrorMap,
        }, () => {

            this.props.invoiceActions.createInvoice(payload).then((result) => {
                if (result && result.invoiceNumber) {
                    this.props.webActions.cupoyStateGo(CupoyRouter.STATES.INVOICE_INFO, {
                        yearmonth: yearMonth,
                        istarttag: result.invoiceNumber.substr(0, 2),
                        invoicenumber: result.invoiceNumber.substr(2),
                    });
                } else {
                    this.setState({
                        isLoading: false,
                        errorMsg: '發生無法處理的錯誤，請聯絡工程師',
                    });
                }

            }, (error) => {

                if (error && error.message) {
                    this.setState({
                        isLoading: false,
                        errorMsg: error.message,
                    });
                } else {
                    this.setState({
                        isLoading: false,
                        errorMsg: '發生無法處理的錯誤，請聯絡工程師',
                    });
                }
            });
        });
    }

    render() {

        const { 
            yearMonth,
            orderid,
            mrscid,
            buyerName,
            buyerEmail,
            invoiceSendAddress,
            isTriCpoy,
            buyerCrn,
            isDonate,
            printMark,
            carrierType,
            carrierId1,
            carrierId2,
            loveCode,
            pdtlist,
            errorMsg,
            isLoading,
            isParamsError,
            isParamsErrorMap,
        } = this.state;

        const {
            yearmonthList,
        } = this.props;

        return (
            <div id="create-invoice">
                <div className="header-bar mix">
                    <h1 className="title">手動開立發票</h1>
                    <div className="button-group">
                        {isParamsError ?
                            <span className="error">部分欄位有誤或未填寫</span>
                            :
                            null
                        }
                        {errorMsg ?
                            <span className="error">{errorMsg}</span>
                            :
                            null
                        }
                        <a className="button blue" onClick={this.handleSubmit}>
                            {isLoading
                                ?
                                <i className="zmdi zmdi-spinner animate-spinner"></i>
                                :
                                null
                            }
                            開立發票
                        </a>
                    </div>
                </div>

                <div className="scroll-content">
                    <div className="form">
                        <div className="block-form">
                            <h3 className="block-title">發票資訊</h3>
                            <div className="block-form-row">
                                <div className="block-form-col">
                                    <h5 className="title">期別</h5>
                                    <div className="form-select">
                                        <select value={yearMonth} onChange={(event) => this.onInputChange('yearMonth', event)}>
                                            {yearmonthList.length === 0 ? '無任何期別的空白發票' : ''}
                                            {yearmonthList.map((_yearmonth, index)=> {
                                                return (<option value={_yearmonth} key={_yearmonth}>{_yearmonth}</option>)
                                            })}
                                        </select>
                                        <div className="select-arrow"><i className="zmdi zmdi-caret-down"></i></div>
                                    </div>
                                </div>
                                <label 
                                    className={classNames("block-form-col", {
                                       'error': isParamsErrorMap['orderid']
                                    })}
                                >
                                    <h5 className="title">
                                        訂單編號
                                        {isParamsErrorMap['orderid'] ? <span className="error-tip">請輸入訂單編號</span> : null}
                                    </h5>
                                    <input
                                        type="text"
                                        value={orderid}
                                        onChange={(event) => this.onInputChange('orderid', event)}
                                    />
                                </label>
                            </div>
                            <div className="block-form-row">
                                <label 
                                    className={classNames("block-form-col", {
                                       'error': isParamsErrorMap['mrscid']
                                    })}
                                >
                                    <h5 className="title">
                                        會員編號
                                        {isParamsErrorMap['mrscid'] ? <span className="error-tip">請輸入會員編號</span> : null}
                                    </h5>
                                    <input
                                        type="text"
                                        value={mrscid}
                                        onChange={(event) => this.onInputChange('mrscid', event)}
                                    />
                                </label>
                                <label 
                                    className={classNames("block-form-col", {
                                       'error': isParamsErrorMap['buyerName']
                                    })}
                                >
                                    <h5 className="title">
                                        買受人
                                        {isParamsErrorMap['buyerName'] ? <span className="error-tip">請輸入買受人</span> : null}
                                    </h5>
                                    <input
                                        type="text"
                                        value={buyerName}
                                        onChange={(event) => this.onInputChange('buyerName', event)}
                                    />
                                </label>
                            </div>
                            <div className="block-form-row">
                                <label 
                                    className={classNames("block-form-col", {
                                       'error': isParamsErrorMap['buyerEmail']
                                    })}
                                >
                                    <h5 className="title">
                                        買受人EMail
                                        {isParamsErrorMap['buyerEmail'] ? <span className="error-tip">請輸入買受人EMail</span> : null}
                                    </h5>
                                    <input
                                        type="text"
                                        value={buyerEmail}
                                        onChange={(event) => this.onInputChange('buyerEmail', event)}
                                    />
                                </label>
                                <label 
                                    className={classNames("block-form-col", {
                                       'error': isParamsErrorMap['invoiceSendAddress']
                                    })}
                                >
                                    <h5 className="title">
                                        發票寄送地址
                                        {isParamsErrorMap['invoiceSendAddress'] ? <span className="error-tip">請輸入發票寄送地址</span> : null}
                                    </h5>
                                    <input
                                        type="text"
                                        value={invoiceSendAddress}
                                        onChange={(event) => this.onInputChange('invoiceSendAddress', event)}
                                    />
                                </label>
                            </div>
                        </div>   
                    </div>

                    <div 
                        className={classNames("block-form", {
                           'none-box-shadow': !isTriCpoy
                        })}
                    >
                        <h3 className="block-title">發票種類與捐贈資訊</h3>
                        <p className="block-description">三聯式發票不得捐贈</p>
                        <div className="block-form-row">
                            <label 
                                className={classNames("block-select-col pointer", {
                                   'blue': !isTriCpoy
                                })}
                                onClick={() => this.changeIsTriCpoy(false)}
                            >
                                <i className="zmdi zmdi-check"></i>
                                二聯式發票
                            </label>
                            <label 
                                className={classNames("block-select-col pointer", {
                                   'blue': isTriCpoy
                                })}
                                onClick={() => this.changeIsTriCpoy(true)}
                            >
                                <i className="zmdi zmdi-check"></i>
                                三聯式發票
                            </label>
                        </div>
                        {isTriCpoy ?
                            <div className="block-form-row">
                                <label 
                                    className={classNames("block-form-col", {
                                       'error': isParamsErrorMap['buyerCrn']
                                    })}
                                >
                                    <h5 className="title">
                                        買受人統編
                                        {isParamsErrorMap['buyerCrn'] ? <span className="error-tip">請輸入買受人統編</span> : null}
                                    </h5>
                                    <input
                                        type="text"
                                        value={buyerCrn}
                                        onChange={(event) => this.onInputChange('buyerCrn', event)}
                                    />
                                </label>
                                <label className="block-form-col">
                                </label>
                            </div>
                            :
                            null
                        }
                    </div>

                    {!isTriCpoy ?
                        <div className="block-form">
                            <div className="block-form-row">
                                <label 
                                    className={classNames("block-select-col pointer", {
                                       'blue': isDonate
                                    })}
                                    onClick={() => this.changeOption(true, false)}
                                >
                                    <i className="zmdi zmdi-check"></i>
                                    捐贈
                                </label>
                                <label 
                                    className={classNames("block-select-col pointer", {
                                       'blue': !isDonate && printMark === 'N'
                                    })}
                                    onClick={() => this.changeOption(false, false)}
                                >
                                    <i className="zmdi zmdi-check"></i>
                                    載具
                                </label>
                                <label 
                                    className={classNames("block-select-col pointer", {
                                       'blue': !isDonate && printMark === 'Y'
                                    })}
                                    onClick={() => this.changeOption(false, true)}
                                >
                                    <i className="zmdi zmdi-check"></i>
                                    寄送
                                </label>
                            </div>

                            {!isDonate && printMark === 'N' ?
                                <div>
                                    <div className="block-form-row">
                                        <label className="block-form-col">
                                            <h5 className="title">載具種類編號</h5>
                                            <div className="form-select">
                                                <select value={carrierType} onChange={(event) => this.onInputChange('carrierType', event)}>
                                                    <option value={GLOBAL.CARRIER_TYPE.MEMBER.value}>
                                                        {GLOBAL.CARRIER_TYPE.MEMBER.label}
                                                    </option>
                                                    <option value={GLOBAL.CARRIER_TYPE.CITIZEN_CERT.value}>
                                                        {GLOBAL.CARRIER_TYPE.CITIZEN_CERT.label}
                                                    </option>
                                                    <option value={GLOBAL.CARRIER_TYPE.MOBILE.value}>
                                                        {GLOBAL.CARRIER_TYPE.MOBILE.label}
                                                    </option>
                                                </select>
                                                <div className="select-arrow"><i className="zmdi zmdi-caret-down"></i></div>
                                            </div>
                                        </label>
                                    </div>
                                    {GLOBAL.CARRIER_TYPE.MEMBER.value === carrierType ?
                                        null
                                        :
                                        <div className="block-form-row">
                                            <label 
                                                className={classNames("block-form-col", {
                                                   'error': isParamsErrorMap['carrierId1']
                                                })}
                                            >
                                                <h5 className="title">
                                                    載具明碼
                                                    {isParamsErrorMap['carrierId1'] ? <span className="error-tip">請輸入載具明碼</span> : null}
                                                </h5>
                                                <input
                                                    type="text"
                                                    value={carrierId1}
                                                    onChange={(event) => this.onInputChange('carrierId1', event)}
                                                />
                                            </label>
                                            <label 
                                                className={classNames("block-form-col", {
                                                   'error': isParamsErrorMap['carrierId2']
                                                })}
                                            >
                                                <h5 className="title">
                                                    載具隱碼
                                                    {isParamsErrorMap['carrierId2'] ? <span className="error-tip">請輸入載具隱碼</span> : null}
                                                </h5>
                                                <input
                                                    type="text"
                                                    value={carrierId2}
                                                    onChange={(event) => this.onInputChange('carrierId2', event)}
                                                />
                                            </label>
                                        </div>
                                    }
                                </div>
                                :
                                null
                            }

                            {isDonate ?
                                <div>
                                    <div className="block-form-row">
                                        <label className="block-form-col">
                                            <h5 className="title">載具種類編號</h5>
                                            <div className="form-select">
                                                <select value={carrierType} onChange={(event) => this.onInputChange('carrierType', event)}>
                                                    <option value={''}>
                                                        不使用
                                                    </option>
                                                    <option value={GLOBAL.CARRIER_TYPE.CITIZEN_CERT.value}>
                                                        {GLOBAL.CARRIER_TYPE.CITIZEN_CERT.label}
                                                    </option>
                                                    <option value={GLOBAL.CARRIER_TYPE.MOBILE.value}>
                                                        {GLOBAL.CARRIER_TYPE.MOBILE.label}
                                                    </option>
                                                </select>
                                                <div className="select-arrow"><i className="zmdi zmdi-caret-down"></i></div>
                                            </div>
                                        </label>
                                        <label 
                                            className={classNames("block-form-col", {
                                               'error': isParamsErrorMap['loveCode']
                                            })}
                                        >
                                            <h5 className="title">
                                                愛心碼
                                                {isParamsErrorMap['loveCode'] ? <span className="error-tip">請輸入愛心碼</span> : null}
                                            </h5>
                                            <input
                                                type="text"
                                                value={loveCode}
                                                onChange={(event) => this.onInputChange('loveCode', event)}
                                            />
                                        </label>
                                    </div>
                                    {!carrierType ?
                                        null
                                        :
                                        <div className="block-form-row">
                                            <label 
                                                className={classNames("block-form-col", {
                                                   'error': isParamsErrorMap['carrierId1']
                                                })}
                                            >
                                                <h5 className="title">
                                                    載具明碼
                                                    {isParamsErrorMap['carrierId1'] ? <span className="error-tip">請輸入載具明碼</span> : null}
                                                </h5>
                                                <input
                                                    type="text"
                                                    value={carrierId1}
                                                    onChange={(event) => this.onInputChange('carrierId1', event)}
                                                />
                                            </label>
                                            <label 
                                                className={classNames("block-form-col", {
                                                   'error': isParamsErrorMap['carrierId2']
                                                })}
                                            >
                                                <h5 className="title">
                                                    載具隱碼
                                                    {isParamsErrorMap['carrierId2'] ? <span className="error-tip">請輸入載具隱碼</span> : null}
                                                </h5>
                                                <input
                                                    type="text"
                                                    value={carrierId2}
                                                    onChange={(event) => this.onInputChange('carrierId2', event)}
                                                />
                                            </label>
                                        </div>
                                    }
                                </div>
                                :
                                null
                            }
                        </div>
                        :
                        null
                    }

                    <div className="block-form">
                        <h3 className="block-title">商品資訊</h3>
                        <div className="block-form-wrapper">
                            {pdtlist.map((product, index) => {
                                return (
                                    <div className="block-form-row" key={index}>
                                        {pdtlist.length > 1 ?
                                            <div 
                                                className="delete-icon hint--left"
                                                onClick={() => this.removeProduct(index)}
                                                data-hint="刪除該商品"
                                            >
                                                <i className="zmdi zmdi-delete"></i>
                                            </div>
                                            :
                                            null
                                        }
                                        <label 
                                            className={classNames("block-form-col", {
                                               'error': product.isParamsErrorMap['pdtname']
                                            })}
                                        >
                                            <h5 className="title">
                                                商品名稱
                                                {product.isParamsErrorMap['pdtname'] ? <span className="error-tip">請輸入商品名稱</span> : null}
                                            </h5>
                                            <input
                                                type="text"
                                                value={product.pdtname}
                                                onChange={(event) => this.onPdtlistInputChange(index, 'pdtname', event)}
                                            />
                                        </label>
                                        <label 
                                            className={classNames("block-form-col", {
                                               'error': product.isParamsErrorMap['pdtid']
                                            })}
                                        >
                                            <h5 className="title">
                                                商品編號
                                                {product.isParamsErrorMap['pdtid'] ? <span className="error-tip">請輸入商品編號</span> : null}
                                            </h5>
                                            <input
                                                type="text"
                                                value={product.pdtid}
                                                onChange={(event) => this.onPdtlistInputChange(index, 'pdtid', event)}
                                            />
                                        </label>
                                        <label 
                                            className={classNames("block-form-col", {
                                               'error': product.isParamsErrorMap['pdtcount']
                                            })}
                                        >
                                            <h5 className="title">
                                                商品數量
                                                {product.isParamsErrorMap['pdtcount'] ? <span className="error-tip">請輸入正確的商品數量</span> : null}
                                            </h5>
                                            <input
                                                type="number"
                                                value={product.pdtcount}
                                                onChange={(event) => this.onPdtlistInputChange(index, 'pdtcount', event)}
                                            />
                                        </label>
                                        <label 
                                            className={classNames("block-form-col", {
                                               'error': product.isParamsErrorMap['pdtprice']
                                            })}
                                        >
                                            <h5 className="title">
                                                商品單價(未稅)
                                                {product.isParamsErrorMap['pdtprice'] ? <span className="error-tip">請輸入正確的商品單價</span> : null}
                                            </h5>
                                            <input
                                                type="number"
                                                value={product.pdtprice}
                                                onChange={(event) => this.onPdtlistInputChange(index, 'pdtprice', event)}
                                            />
                                        </label>
                                    </div>
                                );
                            })}
                        </div>

                        <div 
                            className="block-form-add"
                            onClick={() => this.expandPdtlist()}
                        >
                            <span className="plus-icon"><i className="zmdi zmdi-plus"></i></span>增加銷售明細
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = function(state) {
    return {
        yearmonthList: state.emptyInvoice.yearmonthList,
    }
};

const mapActionToProps = function (dispatch) {
    return {
        invoiceActions: bindActionCreators(actionCreators.invoiceActionCreators, dispatch),
        webActions: bindActionCreators(actionCreators.webActionCreators, dispatch),
        emptyInvoiceActions: bindActionCreators(actionCreators.emptyInvoiceActionCreators, dispatch),
    };
};

export default connect(mapStateToProps, mapActionToProps, null, {withRef: true})(CreateInvoiceView);


// WEBPACK FOOTER //
// ./src/components/invoice/CreateInvoiceView.jsx